<template>
    <img v-bind:src="getSrc" v-bind:class="[classstyle]" ref="v-img">
</template>

<script>
    export default {
        props: {
            src: { default: function () { return ''; }},
            classstyle: { default: function () { return 'img-fluid'; }},
            default: { default: function () { return ''; }},
        },
        data: function() {
            return {}
        },
        computed: {
            getSrc: function() {
                if (!this.src && !this.default) return false;
                if (this.src) return this.src;
                return this.default;
            },
        },
        watch: { 
           src: function (newVal,oldValue) {
                this.src = newVal;
                this.$emit('on-change-src',{
                    component:this
                });
            },
            default: function (newVal,oldValue) {
                this.default = newVal;
            },
        },
        mounted() {
        },
        methods: {
        }
    }
</script>